import { render, staticRenderFns } from "./CSchoolSelect.vue?vue&type=template&id=8d0a8fc0"
import script from "./CSchoolSelect.vue?vue&type=script&lang=js"
export * from "./CSchoolSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports